<template>
  <div>
    <a href="#" @click.prevent="modalsOpen.selector = true">
      <img :src="imageUrl" alt="">
      <p style="font-size: 1.3em;">
        Svara på förfrågningar
      </p>
    </a>

    <SbModal id="modal-survey-replies" v-model="modalsOpen.selector" dialog-class="modal-full" centered hide-footer title="Förfrågningar">
      <template v-if="replies && replies.length > 0">
        <a v-for="reply in replies" :key="reply.id" href="#" @click.prevent="openReply(reply.id)">
          <h5 class="pt-2">{{reply.survey.intro_header}}</h5>
          <img v-if="reply.survey.image_url" :src="reply.survey.image_url" style="width: 100%; height: auto;">

          <div class="text-center my-3">
            <SbButton variant="custom" class="signbuttoninline" @click.prevent.cancel="openReply(reply.id)">
              Svara
            </SbButton>
          </div>
        </a>
      </template>
      <template v-else>
        <p>Du har svarat på alla förfrågningar.</p>
      </template>
    </SbModal>

    <SbModal v-for="reply in replies" :key="reply.id" dialog-class="modal-full" centered hide-footer no-close-on-esc no-close-on-backdrop title="Enkät" :visible="modalsOpen.reply === reply.id" @hidden="onHide(reply.id)">
      <surveys-input
        :submit-url="route('quote.survey_replies.update', [quoteKey, reply.id])"
        :requires-bankid-signature="reply.survey.requires_bankid_signature"
        :bankid-item-id="reply.bankid_item_id"
        :bankid-app-url="reply.bankid_app_url"
        :bankid-signee-name="reply.bankid_signee_name"
        :image-url="reply.survey.image_url"
        :intro-header="reply.survey.intro_header"
        :intro-body="reply.survey.intro_body"
        :thanks-header="reply.survey.thanks_header"
        :thanks-body="reply.survey.thanks_body"
        :questions="reply.survey.questions"
        :quote-key="quoteKey"
        :button-next-enabled="replies.length > 1"
        @close="onClose(reply.id)"
        @next="onNext(reply.id)"
      ></surveys-input>
    </SbModal>
  </div>

</template>

<style lang="scss" scoped>
  a {
    display: block;
    width: 100%;

    img {
      width: 100%;
      height: auto;
      border-top-left-radius: 5px;
      border-top-right-radius: 5px;
      border-bottom-right-radius: 5px;
      border-bottom-left-radius: 5px;
    }

    p {
      margin-top: 8px;
      margin-bottom: 0px;
      text-align: center;
      text-decoration: none;
      color: black;
      text-decoration: none;
    }

    h5 {
      color: black;
    }
  }

  p.preserve-linebrakes {
    white-space: pre-line;
  }
</style>

<script setup lang="ts">
import axios from "axios";
import { nextTick, onMounted, reactive, ref } from "vue";
import { useDocument } from "../../composables/useDocument";
import SbButton from "../sb/SbButton.vue";
import SbModal from "../sb/SbModal.vue";

type Reply = Record<string, any> & { id: number; completed_at?: string | null };
interface Props { quoteKey: string; imageUrl: string; selectorInitiallyOpen: boolean; }
const props = defineProps<Props>();
const documentApi = useDocument();
const replies = ref<Reply[]>([]);
const modalsOpen = reactive<{ selector: boolean; reply: number | null }>({ selector: props.selectorInitiallyOpen, reply: null });
onMounted(async () => {
    const response = await axios.get(route("quote.survey_replies.index", props.quoteKey));
    replies.value = response.data.data.filter((reply: Reply) => !reply.completed_at);
});
async function openReply(replyId: number): Promise<void> {
    modalsOpen.selector = false;
    await nextTick();
    modalsOpen.reply = replyId;
}
function onHide(): void { modalsOpen.reply = null; }
function onClose(replyId: number): void {
    onHide();
    replies.value = replies.value.filter((reply) => reply.id !== replyId);
    if (!replies.value.length) documentApi.locationReload();
}
function onNext(replyId: number): void { onClose(replyId); modalsOpen.reply = replies.value[0]?.id ?? null; }
</script>
